export const states = {
  loadManifest: { availableStates: ['loading'], nextState: 'loading' },
  loading: { availableStates: ['loadComplete'] },
  loadComplete: { availableStates: ['initialization'] },
  initialization: { availableStates: ['initializationComplete'], nextState: 'initializationComplete' },
  initializationComplete: { availableStates: ['tutorial'], nextState: 'tutorial' },
  tutorial: { availableStates: ['initLevel'], nextState: 'initLevel' },
  initLevel: { availableStates: ['showing'], nextState: 'showing' },
  showing: { availableStates: ['showingComplete'] },
  showingComplete: { availableStates: ['playing', 'countdown'], nextState: 'countdown' },
  countdown: { availableStates: ['playing'] },
  playing: { availableStates: ['lose', 'win', 'losing', 'winning', 'paused', 'boosterTutorial', 'showing'] },
  paused: { availableStates: ['playing'] },
  boosterTutorial: { availableStates: ['countdown'] },
  losing: { availableStates: ['lose'] },
  lose: { availableStates: ['initLevel', 'main', 'showing'] },
  winning: { availableStates: ['win'] },
  win: { availableStates: ['initLevel', 'next', 'main'] },
};

export const ignoreNextStates = [
  'showing',
  'boosterTutorial',
  'instructions',
  'countdown',
  'playing',
  'profile',
  'win',
  'next',
  'lose',
  'paused',
];

export const gameControlsData = {
  plugins: ['KeyboardPlugin', 'TouchSegmentPlugin'],
  selectors: { TouchSegmentPlugin: 'canvas' },
  controls: [
    {
      name: 'left',
      keyboard: { keys: [{ keyCode: 37 }, { keyCode: 65 }] },
      touchSegment: { segmentX: [0, 0.49] },
    },
    {
      name: 'right',
      keyboard: { keys: [{ keyCode: 39 }, { keyCode: 68 }] },
      touchSegment: { segmentX: [0.5, 1] },
    },
  ],
};

export const slowBoosterNames = ['jetpack'];
